// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ne-5";
export var filledCircle = "_ne-4";
export var historyEntry = "_ne-3";
export var messageSideLeft = "_ne-1";
export var messageSideRight = "_ne-2";
export var orderTrackingCarouselWrapper = "_ne-6";
export var orderTrackingInfoContainer = "_ne-0";